
export const  PERTRIAL_STATE = {
    0: '待审核',
    1: '预审通过',
    2: '预审不通过',
}
